import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { executeQueryJSON } from '@arcgis/core/rest/query';
import Query from '@arcgis/core/rest/support/Query';
import { MapService } from '@services/map.service';
import { PlanparcelDataService } from '@services/planparcel-data.service';

@Component({
    selector: 'app-eng-parcel-edit',
    // standalone: true,
    // imports: [],
    templateUrl: './eng-parcel-edit.component.html',
    styleUrl: './eng-parcel-edit.component.scss'
})
export class EngParcelEditComponent {
    baladeyaNameOptions: string[] = [];
    baladeyaGeom = {};
    neighNameOptions: string[] = [];
    neighGeom = {};
    planNameOptions: string[] = [];
    planGeom = {};
    parcelNoOptions: string[] = [];
    parcelGeom = {};
    parcelObjectlID: number;
    parcelGloballID: number;
    zoneCode: string = '';
    balady2: string = '';
    areaPhotography: string = '';
    planCorrection: string = '';
    parcelFeature: any;

    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private planparcel: PlanparcelDataService
    ) { }

    ngOnInit() {
        this.queryBaladeyaNames();
    }

    queryBaladeyaNames() {
        //   debugger;
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE';
        const queryObject = new Query({
            where: '1=1',
            returnGeometry: true,
            outFields: ['BELEDIYE']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.baladeyaNameOptions = results.features.map(
                (feature) => feature.attributes.BELEDIYE
            );
            results.features.forEach((feature) => {
                this.baladeyaGeom[feature.attributes.BELEDIYE] =
                    feature.geometry;
                console.log(feature);

                // console.log(feature.geometry.centroid.x);
                // console.log(feature.geometry.centroid.y);
            });
        });
    }

    queryNeighNames(baladeya: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=NEIGH_NAME';
        const queryObject = new Query({
            where: `BELEDIYE = N'${baladeya}'`, // Assuming BELEDIYE is the field name for baladeya
            returnGeometry: true,
            outFields: ['NEIGH_NAME']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.neighNameOptions = results.features.map(
                (feature) => feature.attributes.NEIGH_NAME
            );
            results.features.forEach((feature) => {
                this.neighGeom[feature.attributes.NEIGH_NAME] =
                    feature.geometry;
            });
        });
    }

    queryPlanNames(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONNAME_AR';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: true,
            outFields: ['SUBDIVISIONNAME_AR']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNameOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONNAME_AR
            );
            results.features.forEach((feature) => {
                this.planGeom[feature.attributes.SUBDIVISIONNAME_AR] =
                    feature.geometry;
            });
        });
    }

    queryParcelNo(planNme: string) {
        // SUBDIVISIONPLAN_ID
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=PARCEL_ID';
        const queryObject = new Query({
            where: `SUBDIVISIONPLANNAME_AR = N'${planNme}'`,
            returnGeometry: true,
            outFields: ['PARCEL_ID']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.parcelNoOptions = results.features.map(
                (feature) => feature.attributes.PARCEL_ID
            );
            results.features.forEach((feature) => {
                this.parcelGeom[feature.attributes.PARCEL_ID] =
                    feature.geometry;
                // this.parceObjectlID[feature.attributes.PARCEL_ID]=feature.attributes.OBJECTID;
            });
        });
    }

    queryParcelDetails(parcelNo: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONPLANNAME_AR,PARCEL_ID,zoon_code,BALLADY_2,AREA_PHOTOGRAPHY,Plan_Correction,OBJECTID,GLOBALID';
        const queryObject = new Query({
            where: `PARCEL_ID = N'${parcelNo}'`, // Assuming PARCEL_ID is the field name for parcel number
            returnGeometry: true,
            outFields: [
                'zoon_code',
                'BALLADY_2',
                'AREA_PHOTOGRAPHY',
                'Plan_Correction',
                'OBJECTID',
                'GLOBALID'
            ]
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            if (results.features.length > 0) {
                this.parcelFeature = results.features[0];
                this.zoneCode = this.parcelFeature.attributes.zoon_code;
                this.balady2 = this.parcelFeature.attributes.BALLADY_2;
                this.areaPhotography =
                    this.parcelFeature.attributes.AREA_PHOTOGRAPHY;
                this.planCorrection =
                    this.parcelFeature.attributes.Plan_Correction;
                this.parcelObjectlID = this.parcelFeature.attributes.OBJECTID;

                //  console.log(this.parceObjectlID);
            }
        });
    }

    onBaladeyaNameChange(event: any) {
        // debugger;
        const selectedBaladeya = event.target.value;
        console.log(event.target);
        this.mapService.mapView.goTo(
            this.baladeyaGeom[selectedBaladeya].extent
        );
        this.queryNeighNames(selectedBaladeya);
    }
    onNeighNameChange(event: any) {
        const selectedNeigh = event.target.value;
        this.mapService.mapView.goTo(this.neighGeom[selectedNeigh].extent);
        this.queryPlanNames(selectedNeigh);
    }
    onPlanNameChange(event: any) {
        const selectedPlan = event.target.value;
        this.mapService.mapView.goTo(this.planGeom[selectedPlan].extent);
        this.queryParcelNo(selectedPlan);
    }
    onParcelNoChange(event: any) {
        const selectedParcelNo = event.target.value;
        this.mapService.mapView.goTo(this.parcelGeom[selectedParcelNo].extent);
        this.queryParcelDetails(selectedParcelNo);
    }

    saveParcelDetails() {
        this.parcelFeature.attributes.zoon_code = this.zoneCode;
        this.parcelFeature.attributes.BALLADY_2 = this.balady2;
        this.parcelFeature.attributes.AREA_PHOTOGRAPHY = this.areaPhotography;
        this.parcelFeature.attributes.Plan_Correction = this.planCorrection;
        this.parcelFeature.attributes.OBJECTID = this.parcelObjectlID;

        const flyr = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2'
        });
        // url: 'https://144.76.146.59:6443/arcgis/rest/services/AmanaFinalTestt/AmanaFinalTestt/FeatureServer/3'});

        const requestBody = {
            updateFeatures: [this.parcelFeature]
        };

        const options = {
            // globalIdUsed has to be true when adding, updating or deleting attachments
            globalIdUsed: false,
            rollbackOnFailureEnabled: false
        };

        flyr.applyEdits(requestBody, options)
            .then((editsResult) => {
                if (editsResult.updateFeatureResults.length > 0) {
                    const objectId =
                        editsResult.updateFeatureResults[0].objectId;
                    console.log(editsResult);
                }
            })
            .catch((err) => {
                console.log('===============================================');
                console.error(
                    '[ applyEdits ] FAILURE: ',
                    err.code,
                    err.name,
                    err.message
                );
                console.log('error = ', err);
            });
    }

    // saveEdits(){

    //   var parcelForm:FormData = new FormData();

    //   parcelForm.append('Id', this.parcelObjectlID +'');
    //   parcelForm.append('baladeya2',this.balady2);
    //   parcelForm.append('areaPhotography',this.areaPhotography);
    //   parcelForm.append('planCorrection',this.planCorrection);
    //   parcelForm.append('zoneCode',this.zoneCode);

    //   this.planparcel.saveParcelDash(parcelForm).subscribe((res)=>{

    //   })
    //  }
}
